import BrochureDownload from './BrochureDownload';

export default BrochureDownload;
